import Seo from './Seo'

/* Next */
import Link from 'next/link'

/* Material */
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import SearchIcon from '@mui/icons-material/Search'
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined'
import useStyles from './styles'
import { pageBuilderButtonSx, pageBuilderOutlinedButtonSx } from 'src/theme/pageBuilderButtons'
import StaticBreadcrumbs from 'src/components/Breadcrumbs/StaticBreadcrumbs'

/* Types */
import type { BreadcrumbItem } from 'src/shared/frontendTypes/product'

const breadcrumb: BreadcrumbItem[] = [
  { title: 'Warenkorb' },
]

const WarenkorbLehr = () => {
  const classes = useStyles()

  return <Container maxWidth='lg' className={classes.container}>

    <Seo />

    <StaticBreadcrumbs items={breadcrumb} />
    
    <section className={classes.warenkorbLehr}>
      <div className={classes.emptyCartIcon}>
        <ShoppingBagOutlinedIcon />
      </div>

      <Typo component='div' variant='caption' className={classes.emptyCartEyebrow}>
        Warenkorb
      </Typo>

      <Typo component='h1' variant='h4' color='inherit' gutterBottom>
        Ihr Warenkorb ist leer
      </Typo>

      <Typo component='p' variant='body1' className={classes.emptyCartText}>
        Entdecken Sie passende Produkte oder nutzen Sie die Suche, wenn Sie schon etwas Konkretes im Kopf haben.
      </Typo>

      <div className={classes.emptyCartActions}>
        <Link href='/' passHref legacyBehavior>
          <Button
            color='primary'
            component='a'
            size='large'
            variant='contained'
            endIcon={<ArrowForwardIcon />}
            sx={pageBuilderButtonSx}
          >
            Weiter einkaufen
          </Button>
        </Link>

        <Link href='/suche' passHref legacyBehavior>
          <Button
            color='primary'
            component='a'
            size='large'
            variant='outlined'
            startIcon={<SearchIcon />}
            sx={pageBuilderOutlinedButtonSx}
          >
            Suche öffnen
          </Button>
        </Link>
      </div>

      <div className={classes.emptyCartHelp} />
    </section>
  </Container>

}

export default WarenkorbLehr
